<!--
This is so you can spin up text editors for each note that belongs to
a module. You'll have to deal with the differnt types (TEXT, IMAGE)
as well. They're an object in helpers.js.
-->

<template>
  <div class="p-3 mt-4 bg-white border-1">

    <div class="pb-3">Note Name: {{noteName}} &nbsp;&nbsp;|&nbsp;&nbsp; Note Id: {{noteId}}</div>

    <editor-menu-bar :editor="editor" class="mb-3">
      <div slot-scope="{ commands, isActive }">
        <button :class="{ 'is-active': isActive.bold() }" @click="commands.bold">
          <svg-icon width="30" height="30" icon-name="bold" icon-color="primary"><icon-bold /></svg-icon> 
        </button>

        <button :class="{ 'is-active': isActive.italic() }" @click="commands.italic">
          <svg-icon width="30" height="30" icon-name="italic" icon-color="primary"><icon-italic /></svg-icon> 
        </button>

        <button :class="{ 'is-active': isActive.underline() }" class="mr-3" @click="commands.underline">
          <svg-icon width="30" height="30" icon-name="underline" icon-color="primary"><icon-underline/></svg-icon> 
        </button>

        <button :class="{ 'is-active': isActive.heading({ level: 1 }) }" @click="commands.heading({ level: 1 })">
          H1
        </button>

        <button :class="{ 'is-active': isActive.heading({ level: 2 }) }" @click="commands.heading({ level: 2 })">
          H2
        </button>

        <button :class="{ 'is-active': isActive.heading({ level: 3 }) }" class="mr-3" @click="commands.heading({ level: 3 })">
          H3
        </button>

        <button :class="{ 'is-active': isActive.link() }" @click="commands.link">
          <svg-icon width="30" height="30" icon-name="link" icon-color="primary"><icon-link/></svg-icon> 
        </button>

        <button :class="{ 'is-active': isActive.ordered_list() }" @click="commands.ordered_list">
          <svg-icon width="30" height="30" icon-name="ol" icon-color="primary"><icon-ol/></svg-icon> 
        </button>

        <button :class="{ 'is-active': isActive.bullet_list() }" @click="commands.bullet_list">
          <svg-icon width="30" height="30" icon-name="ul" icon-color="primary"><icon-ul/></svg-icon> 
        </button>
      </div>
    </editor-menu-bar>
    <editor-content :editor="editor" class="border editor-remove-margin-wtf" />

    <button type="button" @click="saveData()" class="btn btn-success mt-3">Save</button>

    <b-alert
      :show="toastCountdown"
      dismissible
      fade
      variant="success"
      @dismissed="toastCountdown=0"
      class="mt-3"
    >
      Saved!
    </b-alert>

  </div>
</template>

<script>
import axios from 'axios'
import IconBold from '@/components/icons/IconBold.vue'
import IconItalic from '@/components/icons/IconItalic.vue'
import IconUnderline from '@/components/icons/IconUnderline.vue'
import IconLink from '@/components/icons/IconLink.vue'
import IconUl from '@/components/icons/IconUl.vue'
import IconOl from '@/components/icons/IconOl.vue'
import SvgIcon from '@/components/display-utils/SvgIcon.vue'
import bAlert from 'bootstrap-vue/es/components/alert/alert'
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
} from 'tiptap-extensions'

export default {
  components: {
    EditorContent,
    EditorMenuBar,
    bAlert,
    SvgIcon,
    IconBold,
    IconItalic,
    IconUnderline,
    IconLink,
    IconUl,
    IconOl
  },
  data () {
    return {
      editor: new Editor({
        extensions: [
          new Blockquote(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new BulletList(),
          new OrderedList(),
          new ListItem(),
          new TodoItem(),
          new TodoList(),
          new Bold(),
          new Code(),
          new Italic(),
          new Link(),
          new Strike(),
          new Underline(),
          new History(),
        ]}),
      toastCountdown: 0,
      toastVariant: "",
      toastText: ""
    }
  },
  props: {
    noteId: {
      type: Number,
      default: 0
    },
    noteName: {
      type: String
    },
    formData: {
      type: String
    },
  },
  created: function() {

  },
  mounted: function() {
    this.setFormData()
  },
    beforeDestroy() {
    this.editor.destroy()
  },
  methods: {
    setFormData: function() {
      this.editor.setContent(this.formData)
    },
    saveData: function() {
      //component reference
      let local = this
      let req = {}
      req.id = this.noteId
      req.note = this.editor.getHTML()

      //ajax query
      axios({
        method: 'post',
        url: this.$helpers.api() + '/admin/module/note/save',
        data: req,
        headers: {'X-Requested-With': 'XMLHttpRequest',
                  'Content-Type': 'application/json',
                  'User-Token': local.$helpers.getToken()}
        })
        .then(function (response) {
          local.toastMessage(true)
        })
        .catch(function (error) {
          local.toastMessage(false)
          console.log("not logged in: ", error)
        });
    },

    toastMessage(value) {
      if (value) {
        this.toastCountdown = 2
        this.toastVariant = "success"
        this.toastText = "Saved!"
      } else {
        this.toastCountdown = 2
        this.toastVariant = "danger"
        this.toastText = "Did not save"
      }
    }
  }
}
</script>

<style scoped>

.editor-remove-margin-wtf {
  margin-top: 0px;
  margin-bottom: 0px;
}

</style>
